import { useState, useEffect } from "react";
import { Form, Spin, Tabs, Row, Col, Input, Button, Select, DatePicker } from "antd";

import dayjs from 'dayjs';

import { NumericFormat, PatternFormat } from "react-number-format";

import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import { apiPrimarias } from "../../../services/api";
import { disabledDate, isStateValid, pushToBase, resetColor } from "../../../utils/utilsFunctions";

import type { IAlteracaoEfpc, ICtrlDoc, IDocumento, IEfpc, IFundamentacaoLegal, IPessoaJuridica, ISelectList } from "../../../components/Interfaces";

import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../messages/messages";
import type { IErroApi } from "../../../services/api";

import { useLocation, useParams } from "react-router";
import CadInfoBotoes from "../../../components/CadInfoBotoes";
import FormModalDocumento from "../../../components/FormModalDocumento";
import { carregaListaDocumento, carregaListaFundamentacaoLegal, carregaListaTipoEfpc } from "../../PessoaJuridica/services";
import { maskNuMatricula } from "../../../utils/maskFunctions";
import TextArea from "antd/es/input/TextArea";


const Alterar = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { tipoAcessoAPagina } = useParams();

  const [form] = Form.useForm();

  const [operacaoAlterarEfpc, setOperacaoAlterarEfpc] = useState<IAlteracaoEfpc>();

  const [dadosEfpc, setDadosEfpc] = useState<IEfpc>();
  const [dadosEfpcPosAlteracao, setDadosEfpcPosAlteracao] = useState<IEfpc>();
  const [pessoaJuridicaEfpc, setPessoaJuridicaEfpc] = useState<IPessoaJuridica>();

  const [efpcDocumento, setEfpcDocumento] = useState<IDocumento[]>([]);
  const [efpcDocumentoOutros, setEfpcDocumentoOutros] = useState<IDocumento[]>([]);
  const [efpcDocumentoAnalise, setEfpcDocumentoAnalise] = useState<IDocumento[]>([]);

  const [ctrlDocsEfpcDocumento, setCtrlDocsEfpcDocumento] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsEfpcDocumentoOutros, setCtrlDocsEfpcDocumentoOutros] = useState<ICtrlDoc[]>([]);
  const [ctrlDocsEfpcDocumentoAnalise, setCtrlDocsEfpcDocumentoAnalise] = useState<ICtrlDoc[]>([]);


  const [erroApi, setErroApi] = useState<IErroApi>()

  const [listFundamentacaoLegal, setListFundamentacaoLegal] = useState<ISelectList[]>([]);
  const [listTipoEfpc, setListTipoEfpc] = useState<ISelectList[]>([]);
  const [fundamentacaoLegal, setFundamentacaoLegal] = useState(-1);
  const [listDocumentosEstatuto, setListDocumentosEstatuto] = useState<ISelectList[]>([]);
  const [listDocumentosOutrosEfpc, setListDocumentosOutrosEfpc] = useState<ISelectList[]>([]);
  const [listDocumentosAnalise, setListDocumentosAnalise] = useState<ISelectList[]>([]);

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [mostrarDetalhesPessoaJuridica, setMostrarDetalhesPessoaJuridica] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)

    setLoading(true);
    //console.log(state);
    const carregaDadosIniciais = async () => {
      if (listFundamentacaoLegal.length === 0) carregaListaFundamentacaoLegalOpcoes();
      if (listTipoEfpc.length === 0) carregaListaTipoEfpcOpcoes();
      if (listDocumentosEstatuto.length === 0) carregaListaDocumentosEstatutoOpcoes();
      if (listDocumentosOutrosEfpc.length === 0) carregaListaDocumentosOutrosEfpcOpcoes();
      if (listDocumentosAnalise.length === 0) carregaListaDocumentosAnaliseOpcoes();
    }
    carregaDadosIniciais();
    setLoading(false);

    if (isStateValid(state)) {
      if (!tipoAcessoAPagina) {
        validaOperacoesAlterarEfpc(state.data);
        validaEfpcRecebidoViaStatus(state.dataEfpcRequerente);
      } else {
        errorMessage("Não foi possível identificar a operação de alteração da Entidade.");
        pushToBase(navigate);
      }
    }

  }, []);

  useEffect(() => {
    if (listFundamentacaoLegal && listFundamentacaoLegal.length > 0 && fundamentacaoLegal >= 0) {
      form.setFieldsValue({
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === fundamentacaoLegal)?.label
      });

    }
  }, [fundamentacaoLegal, listFundamentacaoLegal]);

  useEffect(() => {
    if (listTipoEfpc && listTipoEfpc.length > 0) {
      form.setFieldsValue({
        tipo: listTipoEfpc.find(l => l.value === dadosEfpc?.tipo)?.label
      });

    }
  }, [listTipoEfpc]);

  useEffect(() => {
    if (operacaoAlterarEfpc) {
      form.setFieldsValue({
        operacaoDtPosicao: operacaoAlterarEfpc.dataPosicao ? dayjs(operacaoAlterarEfpc.dataPosicao) : undefined,
        operacaoNumero: operacaoAlterarEfpc.numero,
      });
    }
  }, [operacaoAlterarEfpc]);

  useEffect(() => {
    if (dadosEfpc) {
      setFundamentacaoLegal(dadosEfpc.fundamentacaoLegal);
      setPessoaJuridicaEfpc(dadosEfpc.pessoaJuridicaEfpc);

      form.setFieldsValue({
        sigla: dadosEfpc.sigla,
        numero: maskNuMatricula(dadosEfpc.numero),
        tipo: dadosEfpc.tipo,
        nmFundamentacaoLegal: listFundamentacaoLegal.find(l => l.value === dadosEfpc.fundamentacaoLegal)?.label,
        quantidadeDiretores: dadosEfpc.quantidadeDiretores,
        nmEsi: dadosEfpc.nomeEnquadramento,
        quantidadeConselheiroFiscal: dadosEfpc.quantidadeConselheiroFiscal,
        quantidadeConselhoDeliberativo: dadosEfpc.quantidadeConselhoDeliberativo,
        nmSituacao: dadosEfpc.situacaoAtualEfpc + (dadosEfpc.situacaoAtualSecundariaEfpc ? " - " + dadosEfpc.situacaoAtualSecundariaEfpc : ""),
        dataSituacao: dadosEfpc.dataVigencia ? dayjs(dadosEfpc.dataVigencia).format('DD/MM/YYYY') : undefined,
        dataAprovacaoAutorizacao: dadosEfpc.dataAutorizacao ? dayjs(dadosEfpc.dataAutorizacao).format('DD/MM/YYYY') : undefined,

      });
    }
  }, [dadosEfpc]);

  useEffect(() => {
    if (dadosEfpcPosAlteracao) pushToManter(dadosEfpcPosAlteracao);

  }, [dadosEfpcPosAlteracao]);

  useEffect(() => {
    if (pessoaJuridicaEfpc) {
      form.setFieldsValue({
        efpcNumeroEfpcCnpj: pessoaJuridicaEfpc.tipoIdentificador === 1 ? pessoaJuridicaEfpc.numero : undefined,
        efpcNumeroEfpcProcesso: pessoaJuridicaEfpc.tipoIdentificador === 3 ? pessoaJuridicaEfpc.numero : undefined,
        efpcNumeroProcesso: pessoaJuridicaEfpc.numeroProcesso,
        efpcRazaoSocial: pessoaJuridicaEfpc.razaoSocial
      });
    }
  }, [pessoaJuridicaEfpc]);

  function validaOperacoesAlterarEfpc(opsEfpc: any) {
    if (!opsEfpc || opsEfpc.length === 0) {
      errorMessage("Não foram identificadas operações de alteração para a Requerente");
      pushToBase(navigate);
    } else {
      setOperacaoAlterarEfpc(opsEfpc);
    }
  }

  function validaEfpcRecebidoViaStatus(efpc: any) {
    if (!efpc || efpc.length === 0) {
      errorMessage("Pessoa Juridica da EFPC não identificada");
      pushToBase(navigate);
    } else {
      setDadosEfpc(efpc)
    }
  }

  function pushToManter(efpc: IEfpc) {  // ABRE A TELA DE DETALHES DO DIRETOR
    let tpSelecao = {
      manter: 2,
      data: efpc
    }
    navigate("/" + import.meta.env.VITE_APP_BASE + "/efpc-manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const validarEfpc = () => {
    if (!pessoaJuridicaEfpc || !pessoaJuridicaEfpc.numero || pessoaJuridicaEfpc.numero === "") {
      errorMessage("Não foi possível identificar a Pessoa Jurídica para vincular à Entidade.");
      return;
    }

    // if (!currentForm.efpcNumeroProcesso || currentForm.efpcNumeroProcesso === "") {
    //   errorMessage("Número do processo da EFPC não pode ficar vazio.");
    //   return;
    // }

    form
      .validateFields()
      .then(() => {
        sendForm();
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {

    if (!operacaoAlterarEfpc?.numero || operacaoAlterarEfpc.numero === "") {
      errorMessage("Não foi possível identificar o número da operação de alteração.");
      return
    }
    const currentForm = form.getFieldsValue();

    setTipLoading("Salvando dados ...");
    setLoading(true);

    const json: IEfpc =
    {
      numero: dadosEfpc?.numero || "",
      serie: dadosEfpc?.serie,
      sigla: currentForm.sigla,
      quantidadeDiretores: currentForm.quantidadeDiretores,
      quantidadeConselheiroFiscal: currentForm.quantidadeConselheiroFiscal,
      quantidadeConselhoDeliberativo: currentForm.quantidadeConselhoDeliberativo,
      fundamentacaoLegal: fundamentacaoLegal,
      tipo: 1,
      dataVigencia: currentForm.dataVigencia ? dayjs(currentForm.dataVigencia).format("YYYY-MM-DD") : "", // DATA DE VIGÊNCIA DA ATUAL SITUAÇÃO
      observacoes: currentForm.observacoes,
      justificativaAtualizacao: currentForm.justificativaAtualizacao,
      numeroPessoaJuridica: pessoaJuridicaEfpc ? pessoaJuridicaEfpc.numero : "",
      documentos: [
        ...(efpcDocumento ?? []),
        ...(efpcDocumentoOutros ?? []),
        ...(efpcDocumentoAnalise ?? [])
      ].map((e: IDocumento) => ({ ...e })),
    }

    //console.log("json subindo");
    //console.log(json);

    try {
      let query = `efpc/alteracao/aprovar/${operacaoAlterarEfpc.numero}`;

      const { data } = await apiPrimarias.post(query, json);
      setLoading(false);

      successMessage(
        `Entidade ${data.sigla} (${maskNuMatricula(data.numero)}) alterada com Sucesso`
      );
      setDadosEfpcPosAlteracao(data);

    } catch (error: any) {
      let data: IErroApi = error.response.data;
      let msgErro = data.mensagem ? data.mensagem : error.response.data.message;
      let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
      setEstadoErroApi(error.response.status);
      setMsgErroApi(msgErro + msgDetalheErro);
      if (error.response.status < 500) {
        setErroApi(data);
      } else {
        if (error.response.status === 503)
          errorMessage("Servidor remoto não disponível");
        else
          errorMessage(msgErro);
      }
      setLoading(false);
    }

  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      idEfpc: undefined,
      idPessoaJuridica: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const carregaListaDocumentosEstatutoOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("1126999420598274").then((response) => {
      setCtrlDocsEfpcDocumento(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
      setListDocumentosEstatuto(listaLocal);
    });
  }

  const carregaListaDocumentosOutrosEfpcOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("2252899327440898").then((response) => {
      setCtrlDocsEfpcDocumentoOutros(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosOutrosEfpc(listaLocal);
  }

  const carregaListaDocumentosAnaliseOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaDocumento("4504699141126145").then((response) => {
      setCtrlDocsEfpcDocumentoAnalise(response.data);
      response.data.forEach((p: ICtrlDoc) => {
        listaLocal.push({ value: p.idCtrlDocTpDoc, label: p.nmTpDoc });
      });
    });
    setListDocumentosAnalise(listaLocal);
  }

  const carregaListaFundamentacaoLegalOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaFundamentacaoLegal().then((response) => {
      response.data.forEach((p: IFundamentacaoLegal) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListFundamentacaoLegal(listaLocal);
  }

  const carregaListaTipoEfpcOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaTipoEfpc().then((response) => {
      response.data.forEach((p: IFundamentacaoLegal) => {
        listaLocal.push({ value: p.codigo, label: p.descricao });
      });
    });
    setListTipoEfpc(listaLocal);
  }

  const handleFundamentacaoLegal = async (fundamentacaoLegal: any) => {
    form.setFieldsValue({
      nmFundamentacaoLegal: fundamentacaoLegal.label,
    });
    setFundamentacaoLegal(fundamentacaoLegal.value);
  };

  return (
    <>
      {/* <Prompt
        when={idEfpc !== undefined && idEfpc !== 0}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>

        <Form layout='vertical' style={{ padding: 24 }} form={form} >

          <div className="main-content pl-sm-3 mt-4">
            <h1>Alterar Entidade</h1>
          </div>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações da Operação de Alteração da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} md={12} xl={5}>
              <Form.Item label="Nº Operação"
                name="operacaoNumero">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data da Requisição"
                name="operacaoDtPosicao">
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data Aprovação"
                name="dataVigencia"
                rules={[
                  {
                    required: true,
                    message: "Data aprovação não preenchida",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                />
              </Form.Item>
            </Col>

          </Row>

          <Row>
            <Col xs={24} xl={24}>
              <Form.Item
                label="Justificativa da Alteração"
                name="justificativaAtualizacao"
                rules={[
                  {
                    required: true,
                    message: "Preencha a justificativa da Alteração",
                  },
                ]}
              >
                <TextArea
                  onChange={(e) =>
                    form.setFieldsValue({
                      justificativaAtualizacao: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Básicas da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 2}>
              <Form.Item
                label="CNPJ da Entidade"
                name="efpcNumeroEfpcCnpj">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="##.###.###/####-##"
                />
              </Form.Item>
            </Col>


            <Col xs={24} xl={7} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 3}>
              <Form.Item
                label="Identificador Provisório (Processo)"
                name="efpcNumeroEfpcProcesso">
                <PatternFormat
                  disabled
                  customInput={Input}
                  format="#####.######/####-##"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5} hidden={pessoaJuridicaEfpc?.tipoIdentificador !== 2}>
              <Form.Item
                label="Número do processo"
                name="efpcNumeroProcesso">
                <PatternFormat
                  customInput={Input}
                  format="#####.######/####-##"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={10}>
              <Form.Item label="Razão Social"
                name="efpcRazaoSocial">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4} >
              <Form.Item style={{ alignItems: 'center' }}
                label={mostrarDetalhesPessoaJuridica ? "Ocultar detalhe Cadastro de Pessoa Jurídica" : "Detalhar Cadastro de Pessoa Jurídica"}
              >
                <Button
                  shape='round'
                  onClick={() => {
                    setMostrarDetalhesPessoaJuridica(!mostrarDetalhesPessoaJuridica);
                  }}
                  type='primary'
                  icon={<UserOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Perfil da Entidade</h2>
          </div>

          <Row>
            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Código"
                name="numero"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Sigla"
                name="sigla"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={4}>
              <Form.Item
                label="Tipo"
                name="tipo"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Fundamentação Legal"
                name="nmFundamentacaoLegal"
                rules={[
                  {
                    required: true,
                    message: "Fundamentação Legal obrigatório não preenchido",
                  },
                ]}
              >
                <Select
                  showSearch filterOption optionFilterProp='children'
                  placeholder='SELECIONE UMA FUNDAMENTAÇÃO LEGAL'
                  options={listFundamentacaoLegal}
                  onChange={(_, index) => {
                    handleFundamentacaoLegal(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7}>
              <Form.Item
                label="Tipo de Convenente Predominante"
                name="tipoConvenente"
              >
                <Input placeholder="SEM INFORMAÇÃO" disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>

            {/* <Col xs={24} md={12} xl={3}>
              <Form.Item
                label="ESI"
                name="nmEsi"
              >
                <Input placeholder="SEM INFORMAÇÃO" disabled />
              </Form.Item>
            </Col> */}


            <Col xs={24} xl={7}>
              <Form.Item
                label="Qtd. Máx Diretores Executivos"
                name="quantidadeDiretores"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de diretores Executivos obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de diretores Executivos"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7}>
              <Form.Item
                label="Qtd. Máx Conselheiros Fiscais"
                name="quantidadeConselheiroFiscal"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de Conselheiros Fiscais obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de Conselheiros Fiscais"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={7}>
              <Form.Item
                label="Qtd. Máx Conselheiros Deliberativos"
                name="quantidadeConselhoDeliberativo"
                rules={[
                  {
                    required: true,
                    message:
                      "Qtd. Máx de Conselheiros Deliberativos obrigatório não preenchido",
                  },
                ]}
              >
                <NumericFormat
                  customInput={Input}
                  placeholder="Digitar Qtd. Máx de Conselheiros Deliberativos"
                  allowNegative={false}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={10}>
              <Form.Item
                label="Situação"
                name="nmSituacao">
                <Input disabled={true} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={5}>
              <Form.Item
                label="Data da Situação"
                name="dataSituacao">
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={9}>
              <Form.Item
                label="Qualificação Quanto ao Número de Planos"
                name="qnp"
              >
                <Input placeholder="CAMPO CALCULADO" disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data da Autorização"
                name="dataAprovacaoAutorizacao"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de início de Funcionamento"
                name="dataInicioFuncionamento"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={6}>
              <Form.Item
                label="Data de Encerramento"
                name="dataEncerramento"
              >
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ display: mostrarDetalhesPessoaJuridica ? 'inline' : 'none' }} >
            {/* <>
              <PessoaJuridicaDadosComplementares
                form={form}
                idPessoaFisica={state.idPessoaFisica}
                mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaJuridica}
              />
            </> */}
          </Row>
        </Form>
        <Tabs>
          <Tabs.TabPane tab="Estatuto" key="item-1">
            <>
              <FormModalDocumento
                ctrlDoc={ctrlDocsEfpcDocumento}
                objetoDocumento={efpcDocumento}
                setObjetoDocumento={setEfpcDocumento}
                listaDocumentos={listDocumentosEstatuto}
                manter={3}
              />
            </>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Outros Documentos da Entidade" key="item-2">
            <>
              <FormModalDocumento
                ctrlDoc={ctrlDocsEfpcDocumentoOutros}
                objetoDocumento={efpcDocumentoOutros}
                setObjetoDocumento={setEfpcDocumentoOutros}
                listaDocumentos={listDocumentosOutrosEfpc}
                manter={3}
              />
            </>
          </Tabs.TabPane>

          <Tabs.TabPane tab="Documentação de Análise/Alteração" key="item-3">
            <>
              <FormModalDocumento
                ctrlDoc={ctrlDocsEfpcDocumentoAnalise}
                objetoDocumento={efpcDocumentoAnalise}
                setObjetoDocumento={setEfpcDocumentoAnalise}
                listaDocumentos={listDocumentosAnalise}
                manter={3}
              />
            </>
          </Tabs.TabPane>

        </Tabs>
        <Form layout='vertical' style={{ padding: 24 }} onFinish={validarEfpc} onFinishFailed={onFinishFailed} scrollToFirstError form={form} >

          <CadInfoBotoes
            resetForm={resetForm}
            detalhar={false}
            form={form}
            resetColor={resetColor}
            manter={3}
            msgConfirmacao={`Entidade: ${dadosEfpc?.sigla}`}
            rotaConsultar={"/" + import.meta.env.VITE_APP_BASE}
          />

        </Form>
      </Spin>

    </>
  );
};

export default Alterar;